import React, { Component } from "react";
import {
  Grid,
  Box,
  Button,
  FormControl,
  Menu,
  MenuItem,
  TableContainer,
  Paper,
  Slide,
  Tooltip,
  Collapse,
  IconButton,
} from "@mui/material";
import TableList from "./CustomTool/TableList";
import CtTxt from "./CustomTool/CtTxt";
import CtBtn from "./CustomTool/CtBtn";
import CtCmb from "./CustomTool/CtCmb";
import {
  Edit,
  Delete,
  RefreshOutlined,
  Close,
  MoreHoriz,
  ViewList,
  Save,
  AddBox,
} from "@mui/icons-material";
import Progress from "./CustomTool/Progress";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchPurchase,
  fetchSupplierMaster,
  fetchDetailMaster,
  fetchItemMaster,
} from "./API";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtDtp from "./CustomTool/CtDtp";
import { withRouter } from "../HOC/withRouter";
import PurchaseItemEntry from "./PurchaseItemEntry";
import DetailMaster from "./DetailMaster";
import SupplierMaster from "./SupplierMaster";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  validatedate_min_max,
  copyRowsAllCols,
  isNumeric,
  getTaxNumFromStr,
  getRowColSum,
  getRowColData,
  setKeyboardShortcuts,
  getRowOfRT,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import PaymentModeTable from "./PaymentModeTable";
import moment from "moment";
import PaymentEntry from "./PaymentEntry";
import PaymentModeIcon from "../images/Payment Mode icon.jpg";
import MoreInfoTextEditor from "./MoreInfoTextEditor";
import CtART from "./CustomTool/ResponsiveTable";

class PurchaseEntry extends Component {
  state = {
    SupplierList: [],
    ItemNameList: [],
    StoreList: [],
    PackingList: [],
    TaxNameList: [],
    BillNoList: [],
    DefaultEntrySettingList: [],
    StoreList: [],
    PurchaseInvoiceGeneration: [],
    LedgerNameList: [],
    DetailList: [],
    ispaid: false,
    Type: ["Paid", "Remain"],
    isEditMode: false, // Tracks edit mode
    isInitialLoad: true, // Tracks first load
    hasOpenedTransactionType: false,
    expanded: true,
    DetailListCols: ["bint_displayorderno", "vac_headingvalue"],
    PaymentmodeListCols: [
      "bint_acid",
      "bint_ledgercode",
      "bint_ledgeridsrno",
      "dec_opbalance",
      "vac_backgroundprocess",
      "vac_company",
      "vac_firmname",
      "vac_groupheader",
      "vac_groupname",
      "vac_gstno",
      "vac_ledgername",
    ],
    TransactionType: [{ name: "Paid" }, { name: "Remain" }],
    SupplierStateCode: "",
    columns: [
      // { accessorKey: "Action", header: "Search", name: "Search" },
      {
        accessorKey: "bint_purchaseno",
        header: "Purchase Sr. No.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "bint_itemsrno",
        header: "Sr. No.",
        size: 10,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_storename",
        header: "Store Name",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_itemname",
        header: "Item Name",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      // { accessorKey: "vac_hsncode", header: "HSN",  size: 30,
      // enableColumnActions: false,
      // enableResizing: false,
      // enableSorting: false,
      // enableColumnDragging: false, },
      {
        accessorKey: "vac_unit",
        header: "Packing",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_qty",
        header: "Qty",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_rate",
        header: "Rate",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_basicamt",
        header: "Basic Amt",
        size: 60,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_cashdisper",
        header: "Dis (%)",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_cashdisamt",
        header: "Dis Amt",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_taxableamount",
        header: "Taxable",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_taxname",
        header: "Tax",
        size: 20,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_cgstamt",
        header: "CGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_sgstamt",
        header: "SGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_igstamt",
        header: "IGST",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_totalamount",
        header: "Total Amt",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_remark",
        header: "Remark",
        Cell: ({ cell }) => (
          <div dangerouslySetInnerHTML={{ __html: cell.getValue() }} />
        ),
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],
    rows: [],
    actionList: [
      {
        name: "Edit",
        icon: <Edit />,
        link: "PurchaseEntry:",
        actionType: "AlertResponsive",
      },
      {
        name: "Delete",
        icon: <Delete />,
        link: "PurchaseEntry:",
        actionType: "AlertResponsive",
        hide:
          this.props.userPrivilege.Purchase == "R" ||
          this.props.userPrivilege.Purchase == "W",
      },
    ],
    keyColumn: [
      "bint_itemsrno", //0
      "vac_storename", //1
      "vac_itemname", //2
      "vac_unit", //3
      "dec_qty", //4
      "dec_rate", //5
      "dec_basicamt", //6
      "dec_cashdisper", //7
      "dec_cashdisamt", //8
      "dec_taxableamount", //9
      "vac_taxname", //10
      "dec_cgstamt", //11
      "dec_sgstamt", //12
      "dec_igstamt", //13
      "dec_totalamount", //14
      "vac_remark", //15
    ],

    formData: {
      edit_purchasesrno: "",
      dtpDate: get_YMD_from_SYS(new Date()),
      cmbSupplier: "",
      txtBillNo: "",
      txtbasicamt: 0,
      txtDiscount: "",
      txtTaxable: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtGrandTotal: "",
      txtRoundOff: "",
      txtNetPayment: "",
      cmbTransactionType: "",
      txtRemark: "",
      tblCGST: 0,
      tblSGST: 0,
      tblIGST: 0,
      // txtTDSAmount: 0,
      txtAdvPayment: 0,
    },
    searchData: {
      bint_itemsrno: "",
      vac_storename: "",
      vac_itemname: "",
      vac_hsncode: "",
      vac_unit: "",
      dec_qty: "",
      dec_rate: "",
      dec_basicamt: "",
      dec_cashdisper: "",
      dec_cashdisamt: "",
      dec_taxableamount: "",
      vac_taxname: "",
      dec_cgstamt: "",
      dec_sgstamt: "",
      dec_igstamt: "",
      dec_totalamount: "",
      vac_remark: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
    totalBeforeTaxAmt: 0,
    totalAfterTaxAmt: 0,
    totalafterDeductionTaxamt: 0,
    totalAfteraddTaxamt: 0,
    totalBeforeaddTaxamt: 0,
    totalBeforeDeductionTaxamt: 0,

    columnsOtherDetail: [
      { id: "Action", label: "" },
      { id: "vac_headingvalue", label: "Headings" },
      { id: "txtFormate", label: "" },
      {
        id: "vac_value",
        label: "Values",
        type: "CtTxt",
        CtrlProps: {
          value: "",
          width: 150,
          maxLength: 20,
          amountOnlyCondition: [
            {
              colID: "vac_calculation",
              value: "-",
              relationalOperator: "===",
              logicalOperator: "||",
            },
            {
              colID: "vac_calculation",
              value: "+",
              relationalOperator: "===",
              logicalOperator: "||",
            },
          ],
        },
      },
    ],
    rowsOtherDetail: [],
    rowsOtherDetail1: [],
    rowsCountOtherDetail: 0,
    rowsPerPageOtherDetail: 5,
    rowsCountOtherDetail1: 0,
    rowsPerPageOtherDetail1: 5,

    // columnsPaymentMode: [
    //   { id: "vac_ledgername", label: "Payment Mode Ledger" },
    //   {
    //     id: "dec_amount",
    //     label: "Amount",
    //     type: "CtTxtAmt",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "vac_chequeno",
    //     label: "Cheque No",
    //     type: "CtTxtNum",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "vac_referenceno",
    //     label: "Reference No",
    //     type: "CtTxtNum",
    //     CtrlProps: { value: "", width: 100, maxLength: 20 },
    //   },
    //   {
    //     id: "dat_transactiondate",
    //     label: "Transaction Date",
    //     type: "CtDtp",
    //     CtrlProps: { value: "", maxLength: 20 },
    //   },
    //   {
    //     id: "vac_remark",
    //     label: "Remark",
    //     type: "CtMultiLineText",
    //     CtrlProps: { value: "", width: 120, maxLength: 100 },
    //   },
    //   { id: "vac_groupname", label: "Group Name", hide: true },
    // ],
    rowsPaymentMode: [],
    rowsCountPaymentMode: 0,
    rowsPerPagePaymentMode: 5,
    PaymentData: [],
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Purchase Entry";
    this.props.setActiveMenu("PurchaseEntry");
    this.setSearchColumns();
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
    window.addEventListener("scroll", this.handleScroll);
  }
  componentDidUpdate(prevProps, prevState) {
    const { formData } = this.state;
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);

    let CGST =
      Number(formData.txtCGST) !== 0
        ? Number(formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt || 0) + Number(formData.tblCGST || 0);

    let SGST =
      Number(formData.txtSGST) !== 0
        ? Number(formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt || 0) + Number(formData.tblSGST || 0);

    let IGST =
      Number(formData.txtIGST) !== 0
        ? Number(formData.txtIGST)
        : Number(rowsTotal.dec_igstamt || 0) + Number(formData.tblIGST || 0);

    let txtsubtotal1 =
      Number(formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);

    // console.log("formData.txtTDSAmount", formData.txtTDSAmount);
    console.log("formData.txtAdvPayment", formData.txtAdvPayment);

    let NetPayment =
      Number(txtsubtotal1) -
      // Number(formData.txtTDSAmount) -
      Number(formData.txtAdvPayment);
    let arrNetPayment = getRoundOff(NetPayment);
    let calculatedNetPayment = arrNetPayment["roff_number"];

    if (formData.txtNetPayment !== calculatedNetPayment) {
      this.setState(
        (prevState) => {
          const targetLedgerNames = prevState.DefaultEntrySettingList.map(
            (row) => row.vac_ledgername
          ).filter(Boolean);
          const rowsWithAmount = prevState.rowsPaymentMode.filter(
            (row) => row.dec_amount && row.dec_amount !== 0
          );
          const decAmountCount = rowsWithAmount.length;
          const updatedRowsPaymentMode = prevState.rowsPaymentMode.map(
            (row) => {
              if (
                decAmountCount === 1 &&
                row.dec_amount &&
                row.dec_amount !== 0
              ) {
                return {
                  ...row,
                  dec_amount: parseFloat(calculatedNetPayment),
                };
              } else if (
                (!row.dec_amount || row.dec_amount == 0) &&
                targetLedgerNames.includes(row.vac_ledgername) &&
                (typeof row.chk_paymentmode === "undefined" ||
                  row.chk_paymentmode === true)
              ) {
                return {
                  ...row,
                  dec_amount: parseFloat(calculatedNetPayment),
                };
              }
              return row;
            }
          );
          return {
            formData: {
              ...prevState.formData,
              txtNetPayment: calculatedNetPayment,
            },
            rowsPaymentMode: updatedRowsPaymentMode,
          };
        },
        () => {
          console.log("Updated payment modes:", this.state.rowsPaymentMode);
        }
      );
      // this.setState((prevState) => ({
      //   formData: {
      //     ...prevState.formData,
      //     txtNetPayment: calculatedNetPayment,
      //   },
      // }));
    }
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
    window.removeEventListener("scroll", this.handleScroll);
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name === "cmbSupplier") {
          this.getStateCodeOFPurchase();
        } else if (e.target.name === "txtAdvPayment") {
          // this.calNetAmount();
        }
        if (e.target.name === "cmbTransactionType") {
          if (this.state.formData.cmbTransactionType === "Paid") {
            if (
              this.state.formData.cmbTransactionType === "Paid" &&
              !this.state.isInitialLoad &&
              !this.state.hasOpenedTransactionType
            ) {
              this.handleSelectTransactionType();
            }
            // Reset initial load after first change
            if (this.state.isInitialLoad) {
              this.setState({ isInitialLoad: false });
            }
          } else if (this.state.formData.cmbTransactionType === "Remain") {
            this.setState({ hasOpenedTransactionType: false });
          }

          // this.calNetAmount();
        }
      }
    );
  };

  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickSave: this.savePurchase,
        handleOnclickNew: this.clearInfo,
        handleOnclickDelete: this.onDeleteBtnClick,
        handleOnclickPluse: this.onAddClickSupplier,
        handleOnclickAdd: this.handleOnNewEntryClick,
        handleOnclickList: () => {
          this.props.navigateTo("PurchaseList");
        },
        handleOnClickRemark: () => {
          this.openRichTextBox(
            "Remark",
            "Remark",
            this.state.formData.txtRemark
          );
        },
      }),
    });
  };

  handleARDonActionClick = (row) => {
    console.log("call");

    console.log("row", row);

    let bint_itemsrno = row.bint_itemsrno,
      vac_itemname = row.vac_itemname,
      actionName = row.actionName,
      edit_purchasesrno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid"),
      EditPurchaseItemData = [],
      SupplierStateCode = "";

    if (actionName === "Edit") {
      let ARD = null;
      EditPurchaseItemData = [
        {
          bint_itemsrno: row.bint_itemsrno,
          vac_itemname: row.vac_itemname,
          // vac_hsncode: row.vac_hsncode,
          vac_unit: row.vac_unit,
          dec_qty: row.dec_qty,
          dec_rate: row.dec_rate,
          dec_basicamt: row.dec_basicamt,
          dec_disper: row.dec_cashdisper,
          dec_disamt: row.dec_cashdisamt,
          dec_taxable: row.dec_taxableamount,
          vac_taxname: row.vac_taxname,
          dec_cgstamt: row.dec_cgstamt,
          dec_sgstamt: row.dec_sgstamt,
          dec_igstamt: row.dec_igstamt,
          dec_totalamt: row.dec_totalamount,
          vac_remark: row.vac_remark,
          vac_storename: row.vac_storename,
        },
      ];
      this.setState({ ARD }, () => {
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            // Edit : Sales Item Entry
            alertMessage={
              <PurchaseItemEntry
                bint_itemsrno={bint_itemsrno}
                edit_purchasesrno={edit_purchasesrno}
                getItemList={this.getItemList}
                refreshPurchaseItemList={this.refreshPurchaseItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                EditPurchaseItemData={EditPurchaseItemData}
                dtpDate={this.state.formData.dtpDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                txtBillNo={this.state.formData.txtBillNo}
                cmbSupplier={this.state.formData.cmbSupplier}
                SupplierStateCode={this.state.SupplierStateCode}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={
                  this.getPaymentModeDataStatus()
                    ? this.state.rowsPaymentMode
                    : []
                }
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
                totalAfterTaxAmt={this.state.totalAfterTaxAmt}
                txtbasicamt={this.state.formData.txtbasicamt}
                totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
                totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
                totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
                totalBeforeDeductionTaxamt={
                  this.state.totalBeforeDeductionTaxamt
                }
                // txtTDSAmount={this.state.formData.txtTDSAmount}
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD }, () => {
          // console.log("this.state.ARD", this.state.ARD);
        });
      });
    } else if (actionName === "Delete") {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchaseItem(
                bint_acyear,
                bint_acid,
                edit_purchasesrno,
                bint_itemsrno
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "vac_itemname",
      "bint_itemsrno",
      "bint_purchaseno",
      "vac_itemname",
      "vac_unit",
      "dec_qty",
      "dec_rate",
      "dec_basicamt",
      "dec_cashdisper",
      "dec_cashdisamt",
      "dec_taxableamount",
      "vac_taxname",
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
      "dec_totalamount",
      "vac_remark",
      "vac_storename",
    ]);
    const vac_itemname = row.vac_itemname,
      bint_itemsrno = row.bint_itemsrno,
      edit_salessrno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid");

    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelAgree="Delete"
          labelDisagree="Cancel"
          alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
          alertMessage=""
          handleOnClickYes={() => {
            return this.deleteSalesItem(
              bint_acyear,
              bint_acid,
              edit_salessrno,
              bint_itemsrno
            );
          }}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    let EditPurchaseItemData = [];
    const row = getRowOfRT(rtRow, [
      "vac_itemname",
      "bint_itemsrno",
      "bint_purchaseno",
      "bint_itemsrno",
      "vac_itemname",
      "vac_unit",
      "dec_qty",
      "dec_rate",
      "dec_basicamt",
      "dec_cashdisper",
      "dec_cashdisamt",
      "dec_taxableamount",
      "vac_taxname",
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
      "dec_totalamount",
      "vac_remark",
      "vac_storename",
    ]);
    const vac_itemname = row.vac_itemname,
      bint_itemsrno = row.bint_itemsrno,
      edit_purchasesrno = row.bint_purchaseno,
      bint_acyear = localStorage.getItem("ACY"),
      bint_acid = localStorage.getItem("acid");

    let ARD = null;
    EditPurchaseItemData = [
      {
        bint_itemsrno: row.bint_itemsrno,
        vac_itemname: row.vac_itemname,
        // vac_hsncode: row.vac_hsncode,
        vac_unit: row.vac_unit,
        dec_qty: row.dec_qty,
        dec_rate: row.dec_rate,
        dec_basicamt: row.dec_basicamt,
        dec_disper: row.dec_cashdisper,
        dec_disamt: row.dec_cashdisamt,
        dec_taxable: row.dec_taxableamount,
        vac_taxname: row.vac_taxname,
        dec_cgstamt: row.dec_cgstamt,
        dec_sgstamt: row.dec_sgstamt,
        dec_igstamt: row.dec_igstamt,
        dec_totalamt: row.dec_totalamount,
        vac_remark: row.vac_remark,
        vac_storename: row.vac_storename,
      },
    ];
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // Edit : Sales Item Entry
          alertMessage={
            <PurchaseItemEntry
              bint_itemsrno={bint_itemsrno}
              edit_purchasesrno={edit_purchasesrno}
              getItemList={this.getItemList}
              refreshPurchaseItemList={this.refreshPurchaseItemList}
              resetAmount={this.resetAmount}
              bint_acid={localStorage.getItem("acid")}
              bint_acyear={localStorage.getItem("ACY")}
              ItemNameList={this.state.ItemNameList}
              TaxNameList={this.state.TaxNameList}
              StoreList={this.state.StoreList}
              EditPurchaseItemData={EditPurchaseItemData}
              dtpDate={this.state.formData.dtpDate}
              cmbCompany={localStorage.getItem("CompanyName")}
              txtBillNo={this.state.formData.txtBillNo}
              cmbSupplier={this.state.formData.cmbSupplier}
              SupplierStateCode={this.state.SupplierStateCode}
              txtDiscount={this.state.formData.txtDiscount}
              txtTaxable={this.state.formData.txtTaxable}
              txtCGST={this.state.formData.txtCGST}
              txtSGST={this.state.formData.txtSGST}
              txtIGST={this.state.formData.txtIGST}
              txtGrandTotal={this.state.formData.txtGrandTotal}
              txtAdvPayment={this.state.formData.txtAdvPayment}
              txtNetPayment={this.state.formData.txtNetPayment}
              txtRoundOff={this.state.formData.txtRoundOff}
              cmbTransactionType={this.state.formData.cmbTransactionType}
              txtRemark={this.state.formData.txtRemark}
              rowsPaymentMode={
                this.getPaymentModeDataStatus()
                  ? this.state.rowsPaymentMode
                  : []
              }
              rowsOtherDetail={this.state.rowsOtherDetail}
              rowsOtherDetail1={this.state.rowsOtherDetail1}
              totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
              totalAfterTaxAmt={this.state.totalAfterTaxAmt}
              txtbasicamt={this.state.formData.txtbasicamt}
              totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
              totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
              totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
              totalBeforeDeductionTaxamt={this.state.totalBeforeDeductionTaxamt}
              // txtTDSAmount={this.state.formData.txtTDSAmount}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD }, () => {
        // console.log("this.state.ARD", this.state.ARD);
      });
    });
  };
  // handleARDonActionClick = (values) => {
  //   let bint_itemsrno = values[0].value,
  //     vac_itemname = values[2].value,
  //     actionName = values[0].actionName,
  //     edit_purchasesrno = this.state.formData.edit_purchasesrno,
  //     bint_acyear = localStorage.getItem("ACY"),
  //     bint_acid = localStorage.getItem("acid"),
  //     EditPurchaseItemData = [],
  //     SupplierStateCode = "";
  //   if (actionName === "Edit") {
  //     let ARD = null;
  //     EditPurchaseItemData = [
  //       {
  //         bint_itemsrno: values[0].value,
  //         vac_storename: values[1].value,
  //         vac_itemname: values[2].value,
  //         vac_unit: values[3].value,
  //         dec_qty: values[4].value,
  //         dec_rate: values[5].value,
  //         dec_basicamt: values[6].value,
  //         dec_disper: values[7].value,
  //         dec_disamt: values[8].value,
  //         dec_taxable: values[9].value,
  //         vac_taxname: values[10].value,
  //         dec_cgstamt: values[11].value,
  //         dec_sgstamt: values[12].value,
  //         dec_igstamt: values[13].value,
  //         dec_totalamt: values[14].value,
  //         vac_remark: values[15].value,
  //       },
  //     ];
  //     this.setState({ ARD }, () => {
  //       ARD = (
  //         <AlertResponsiveDialog
  //           labelDisagree="Close"
  //           alertMessage={
  //             <PurchaseItemEntry
  //               bint_itemsrno={bint_itemsrno}
  //               edit_purchasesrno={edit_purchasesrno}
  //               getItemList={this.getItemList}
  //               refreshPurchaseItemList={this.refreshPurchaseItemList}
  //               resetAmount={this.resetAmount}
  //               bint_acid={localStorage.getItem("acid")}
  //               bint_acyear={localStorage.getItem("ACY")}
  //               ItemNameList={this.state.ItemNameList}
  //               TaxNameList={this.state.TaxNameList}
  //               StoreList={this.state.StoreList}
  //               EditPurchaseItemData={EditPurchaseItemData}
  //               dtpDate={this.state.formData.dtpDate}
  //               cmbCompany={localStorage.getItem("CompanyName")}
  //               txtBillNo={this.state.formData.txtBillNo}
  //               cmbSupplier={this.state.formData.cmbSupplier}
  //               SupplierStateCode={this.state.SupplierStateCode}
  //               txtDiscount={this.state.formData.txtDiscount}
  //               txtTaxable={this.state.formData.txtTaxable}
  //               txtCGST={this.state.formData.txtCGST}
  //               txtSGST={this.state.formData.txtSGST}
  //               txtIGST={this.state.formData.txtIGST}
  //               txtGrandTotal={this.state.formData.txtGrandTotal}
  //               txtAdvPayment={this.state.formData.txtAdvPayment}
  //               txtNetPayment={this.state.formData.txtNetPayment}
  //               txtRoundOff={this.state.formData.txtRoundOff}
  //               cmbTransactionType={this.state.formData.cmbTransactionType}
  //               txtRemark={this.state.formData.txtRemark}
  //               rowsPaymentMode={
  //                 this.getPaymentModeDataStatus()
  //                   ? this.state.rowsPaymentMode
  //                   : []
  //               }
  //               rowsOtherDetail={this.state.rowsOtherDetail}
  //               totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
  //               totalAfterTaxAmt={this.state.totalAfterTaxAmt}
  //             />
  //           }
  //           defaultOpenDialog={true}
  //           onYesClickCloseIfExeSuccessfully={true}
  //         />
  //       );
  //       this.setState({ ARD }, () => {
  //         // console.log("this.state.ARD", this.state.ARD);
  //       });
  //     });
  //   } else if (actionName === "Delete") {
  //     this.setState({ ARD: null }, () => {
  //       let ARD = (
  //         <AlertResponsiveDialog
  //           labelAgree="Delete"
  //           labelDisagree="Cancel"
  //           alertTitle={"Do you want to Delete Item : " + vac_itemname + " ?"}
  //           alertMessage=""
  //           handleOnClickYes={() => {
  //             return this.deletePurchaseItem(
  //               bint_acyear,
  //               bint_acid,
  //               edit_purchasesrno,
  //               bint_itemsrno
  //             );
  //           }}
  //           defaultOpenDialog={true}
  //           onYesClickCloseIfExeSuccessfully={true}
  //         />
  //       );

  //       this.setState({ ARD });
  //     });
  //   }
  // };

  handleOnSearchInputChange = (e) => {
    // console.log('handleOnSearchInputChange', [e.target.name], e.target.value, this.state.searchData);
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen, this.state.searchData);
        // console.log(this.state.searchData)
      }
    );
  };

  handleScroll = () => {
    if (window.scrollY > 200 && this.state.expanded) {
      this.setState({ expanded: false });
    } else if (window.scrollY < 200) {
      this.setState({ expanded: true });
    }
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vac_storename.length === 0 ||
            (row["vac_storename"] &&
              row["vac_storename"]
                .toString()
                .toLowerCase()
                .includes(
                  this.state.searchData.vac_storename.toLowerCase()
                ))) &&
          (this.state.searchData.vac_itemname.length === 0 ||
            (row["vac_itemname"] &&
              row["vac_itemname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_itemname.toLowerCase()))) &&
          (this.state.searchData.vac_unit.length === 0 ||
            (row["vac_unit"] &&
              row["vac_unit"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_unit.toLowerCase()))) &&
          (this.state.searchData.vac_remark.length === 0 ||
            (row["vac_remark"] &&
              row["vac_remark"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_remark.toLowerCase()))) &&
          (this.state.searchData.vac_taxname.length === 0 ||
            (row["vac_taxname"] &&
              row["vac_taxname"]
                .toString()
                .toLowerCase()
                .includes(this.state.searchData.vac_taxname.toLowerCase()))) &&
          (this.state.searchData.dec_qty.length === 0 ||
            (row["dec_qty"] &&
              Number(row["dec_qty"]) ==
                Number(this.state.searchData.dec_qty))) &&
          (this.state.searchData.dec_rate.length === 0 ||
            (row["dec_rate"] &&
              Number(row["dec_rate"]) ==
                Number(this.state.searchData.dec_rate)))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {}
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnNewEntryClick = () => {
    if (this.validatePurchase() === true) {
      let ARD = null;
      this.setState({ ARD }, () => {
        this.removeKeyboardShortCuts();
        ARD = (
          <AlertResponsiveDialog
            labelDisagree="Close"
            alertMessage={
              <PurchaseItemEntry
                refreshPurchaseItemList={this.refreshPurchaseItemList}
                getItemList={this.getItemList}
                resetAmount={this.resetAmount}
                bint_acid={localStorage.getItem("acid")}
                bint_acyear={localStorage.getItem("ACY")}
                ItemNameList={this.state.ItemNameList}
                PackingList={this.state.PackingList}
                TaxNameList={this.state.TaxNameList}
                StoreList={this.state.StoreList}
                edit_purchasesrno={this.state.formData.edit_purchasesrno}
                dtpDate={this.state.formData.dtpDate}
                cmbCompany={localStorage.getItem("CompanyName")}
                txtBillNo={this.state.formData.txtBillNo}
                // bint_billno={this.state.formData.txtBillNo}
                cmbSupplier={this.state.formData.cmbSupplier}
                SupplierStateCode={this.state.SupplierStateCode}
                // cmbShipTo={this.state.formData.cmbShipTo}
                // txtOtherDetail={this.state.formData.txtOtherDetail}
                txtDiscount={this.state.formData.txtDiscount}
                txtTaxable={this.state.formData.txtTaxable}
                txtCGST={this.state.formData.txtCGST}
                txtSGST={this.state.formData.txtSGST}
                txtIGST={this.state.formData.txtIGST}
                txtGrandTotal={this.state.formData.txtGrandTotal}
                // txtTDSAmount={this.state.formData.txtTDSAmount}
                txtAdvPayment={this.state.formData.txtAdvPayment}
                txtNetPayment={this.state.formData.txtNetPayment}
                txtRoundOff={this.state.formData.txtRoundOff}
                cmbTransactionType={this.state.formData.cmbTransactionType}
                txtRemark={this.state.formData.txtRemark}
                rowsPaymentMode={
                  this.getPaymentModeDataStatus()
                    ? this.state.rowsPaymentMode
                    : []
                }
                rowsOtherDetail={this.state.rowsOtherDetail}
                rowsOtherDetail1={this.state.rowsOtherDetail1}
                totalBeforeTaxAmt={this.state.totalBeforeTaxAmt}
                totalAfterTaxAmt={this.state.totalAfterTaxAmt}
                txtbasicamt={this.state.formData.txtbasicamt}
                totalafterDeductionTaxamt={this.state.totalafterDeductionTaxamt}
                totalAfteraddTaxamt={this.state.totalAfteraddTaxamt}
                totalBeforeaddTaxamt={this.state.totalBeforeaddTaxamt}
                totalBeforeDeductionTaxamt={
                  this.state.totalBeforeDeductionTaxamt
                }
              />
            }
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
            handleOnClickNo={() => {
              this.ShortCut();
            }}
          />
        );
        this.setState({ ARD });
      });
    }
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClickOtherDetail = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<DetailMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={this.getDetailList}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPagePaymentMode = (rowsPerPagePaymentMode) => {
    this.setState({ rowsPerPagePaymentMode });
  };

  handleOnRowDataChangeOtherDetail = (
    rowsOtherDetail,
    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;

        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
            }
          }
        });
        let tblIGST = Number(plustblIGST) + Number(minustblIGST);
        this.setState(
          {
            rowsOtherDetail,
            rowsCountOtherDetail: rowsOtherDetail.length,

            formData: {
              ...this.state.formData,
            },
          },
          () => {}
        );
        // console.log("rowsOtherDetail", rowsOtherDetail);
      }
    );
  };
  handleOnRowDataChangeOtherDetail1 = (
    rowsOtherDetail1,
    handledRowIndex,
    colID
  ) => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          tblCGST: 0,
          tblSGST: 0,
          tblIGST: 0,
        },
      },
      () => {
        let totalBeforeTaxAmt = 0;
        let totalAfterTaxAmt = 0;
        let totalAfteraddTaxamt = 0;
        let totalafterDeductionTaxamt = 0;
        let totalBeforeaddTaxamt = 0;
        let totalBeforeDeductionTaxamt = 0;
        let tblCGST = 0,
          tblSGST = 0,
          minustblIGST = 0,
          plustblIGST = 0;
        if (isNumeric(this.state.formData.tblCGST)) {
          tblCGST = Number(this.state.formData.tblCGST);
        }
        if (isNumeric(this.state.formData.tblSGST)) {
          tblSGST = Number(this.state.formData.tblSGST);
        }
        if (isNumeric(this.state.formData.tblIGST)) {
          minustblIGST = Number(this.state.formData.tblIGST);
          plustblIGST = Number(this.state.formData.tblIGST);
        }
        rowsOtherDetail1.map((row, index) => {
          if (isNumeric(row["vac_value"])) {
            let value = Number(row["vac_value"]);
            if (row["vac_taxname"] && row["vac_calculation"] == "+") {
              totalBeforeTaxAmt += value;
              totalBeforeaddTaxamt += value;

              let result = this.taxCalcualte(
                row,
                "+",
                tblCGST,
                tblSGST,
                plustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              plustblIGST = Number(result.tblIGST);
            } else if (row["vac_taxname"] && row["vac_calculation"] == "-") {
              totalBeforeTaxAmt -= value;
              totalBeforeDeductionTaxamt -= value;

              let result = this.taxCalcualte(
                row,
                "-",
                tblCGST,
                tblSGST,
                minustblIGST
              );
              tblCGST = Number(result.tblCGST);
              tblSGST = Number(result.tblSGST);
              minustblIGST = Number(result.tblIGST);
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "+"
            ) {
              totalAfterTaxAmt += value;
              totalAfteraddTaxamt += value;
            } else if (
              row["vac_calculationstyle"] == "After Tax" &&
              row["vac_calculation"] == "-"
            ) {
              totalAfterTaxAmt -= value;
              totalafterDeductionTaxamt -= value;
            }
          }
        });

        let tblIGST = Number(plustblIGST) + Number(minustblIGST);

        this.setState(
          {
            rowsOtherDetail1,
            rowsCountOtherDetail1: rowsOtherDetail1.length,
            totalBeforeTaxAmt,
            totalAfterTaxAmt,
            totalAfteraddTaxamt,
            totalafterDeductionTaxamt,
            totalBeforeDeductionTaxamt,
            totalBeforeaddTaxamt,
            formData: {
              ...this.state.formData,
              tblCGST: Number(tblCGST),
              tblSGST: Number(tblSGST),
              tblIGST: Number(tblIGST),
              txtCGST: 0,
              txtSGST: 0,
              txtIGST: 0,
            },
          },
          () => {
            // this.calNetAmount();
          }
        );
      }
    );
  };

  taxCalcualte = (row, icon, tblCGST, tblSGST, tblIGST) => {
    if (isNumeric(row["vac_value"])) {
      let value = Number(row["vac_value"]);
      if (row["vac_taxname"].length > 0) {
        const txtTaxable = value,
          TaxName = getTaxNumFromStr(row["vac_taxname"]);

        if (Number(txtTaxable) != 0 && Number(TaxName) >= 0) {
          tblCGST =
            icon == "+"
              ? tblCGST + (txtTaxable * (TaxName / 2)) / 100
              : tblCGST - (txtTaxable * (TaxName / 2)) / 100;
          tblCGST = Number(tblCGST);
          tblCGST = tblCGST.toFixed(2);
          tblSGST = tblCGST;

          if (
            this.state.SupplierStateCode !=
            localStorage.getItem("CompStateCode")
          ) {
            tblIGST = Number(tblCGST) + Number(tblSGST);
            tblCGST = 0;
            tblSGST = 0;
          }
        }
      }
    }
    return { tblCGST, tblSGST, tblIGST };
  };

  handleOnRowDataChangePaymentMode = (
    rowsPaymentMode,
    handledRowIndex,
    colID
  ) => {
    this.setState({
      rowsPaymentMode,
      rowsCountPaymentMode: rowsPaymentMode.length,
    });
  };
  //#endregion handle

  //#region function
  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "Lbl",
        label: "Sr. No.",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_storename",
        // items: this.state.ItemName,
        label: "Store Name",
        value: this.state.searchData.vac_storename,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        maxLength: "100",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_itemname",
        maxLength: "100",
        // items: this.state.ItemName,
        label: "Item Name",
        value: this.state.searchData.vac_itemname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "120",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "vac_unit",
        // items: this.state.Packing,
        label: "Packing",
        value: this.state.searchData.vac_unit,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "CtTxt",
        id: "dec_qty",
        label: "Quantity",
        value: this.state.searchData.dec_qty,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "dec_rate",
        label: "Rate",
        value: this.state.searchData.dec_rate,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_basicamt",
        label: "Basic Amount",
        value: this.state.searchData.dec_basicamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        label: "Dis (%)",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Dis Amt",
        width: "100",
      },
      {
        cType: "Lbl",
        label: "Taxable",
        width: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_taxname",
        // items: this.state.TaxName,
        label: "Tax Name",
        value: this.state.searchData.vac_taxname,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        // colID: 'status',
      },
      {
        cType: "Lbl",
        id: "dec_cgstamt",
        label: "CGST",
        value: this.state.searchData.dec_cgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_sgstamt",
        label: "SGST",
        value: this.state.searchData.dec_sgstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_igstamt",
        label: "IGST",
        value: this.state.searchData.dec_igstamt,
        handleOnChange: this.handleOnSearchInputChange,
        width: "80",
        maxLength: "100",
      },
      {
        cType: "Lbl",
        id: "dec_totalamt",
        label: "Total amt",
        value: this.state.searchData.dec_totalamount,
        handleOnChange: this.handleOnSearchInputChange,
        width: "110",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "vac_remark",
        label: "Remark",
        value: this.state.searchData.vac_remark,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({ formData: this.state.formData });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validatePurchase = () => {
    let result = false;
    // console.log(applyTrimOnObjectValues(this.state.formData,['cmbSupplier']))
    if (this.state.formData.dtpDate.length <= 0) {
      this.props.toastErrorMsg("Enter Date", "dtpDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpDate,
        "dtpDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return false;
    } else if (this.state.formData.txtBillNo.length <= 0) {
      this.props.toastErrorMsg("Enter Bill No", "txtBillNo");
    } else if (this.state.formData.cmbSupplier.length <= 0) {
      this.props.toastErrorMsg("Select Supplier Name", "cmbSupplier");
    } else if (
      isValidItem(
        this.state.SupplierList,
        "vac_supplier",
        this.state.formData.cmbSupplier
      ) == false
    ) {
      this.props.toastErrorMsg("Select Valid Supplier Name", "cmbSupplier");
    } else if (this.state.formData.cmbTransactionType.length <= 0) {
      this.props.toastErrorMsg("Select Transaction Type", "cmbTransactionType");
    } else {
      result = true;
    }
    return result;
  };

  validatePurchaseItemCount = () => {
    let result = false;
    if (this.state.rowsCount <= 0) {
      this.props.toastErrorMsg("Enter atleast one item", "dtpDate");
    } else {
      result = true;
    }
    return result;
  };

  validatePaymentModeAmount = () => {
    let result = false,
      dec_amount = 0;
    // console.log("call1");

    if (
      this.getPaymentModeDataStatus &&
      this.state.rowsPaymentMode.length > 0
    ) {
      // console.log("call2");
      this.state.rowsPaymentMode.map((row) => {
        // console.log("call3");
        console.log("call4", row.dec_amount);
        if (row.dec_amount != undefined) {
          dec_amount += Number(row.dec_amount);
        }
      });
      // console.log("call5", this.state.formData.cmbTransactionType);
      // console.log(
      //   "condition",
      //   this.state.formData.cmbTransactionType.trim() === "Paid"
      // );

      if (this.state.formData.cmbTransactionType === "Paid") {
        // console.log("call5");
        if (dec_amount == Number(this.state.formData.txtNetPayment)) {
          // console.log("call6");
          result = true;
        } else {
          // console.log("call7");
          this.props.toastErrorMsg(
            "Net Payment Amount and Payment Mode Ledger Amount must be same"
          );
        }
      } else if (this.state.formData.cmbTransactionType === "Remain") {
        // console.log("call8");
        result = true;
      }
    } else {
      result = true;
    }
    return result;
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState(
      {
        dataLoadStatus,
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: [],
        rowsOtherDetail1: [],

        rowsCountOtherDetail: 0,
        rowsCountOtherDetail1: 0,

        rowsPaymentMode: [],
        rowsCountPaymentMode: 0,
        LedgerNameList: [],
        DetailList: [],
        isInitialLoad: true,
      },
      () => {
        // console.log("this.props.location", this.props.location);
        // console.log("this.props.location.state", this.props.location.state);
        let bint_acyear = 0,
          bint_acid = "",
          edit_purchasesrno = 0;
        if (this.props.location.state && this.props.location.state != null) {
          this.setState({ isEditMode: true });
          // var editInfo = this.props.params.EditPurchaseSrNo.split(":");
          bint_acid = this.props.location.state.bint_acid;
          edit_purchasesrno = this.props.location.state.bint_purchaseno;
          bint_acyear = this.props.location.state.bint_acyear;
          let reqData = {
            Op: "PurchaseData",
            bint_acyear,
            bint_acid,
            edit_purchaseno: edit_purchasesrno,
          };
          fetchPurchase(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let SupplierList = res.data.supplierList,
                TaxNameList = res.data.TaxList,
                ItemNameList = res.data.ItemList,
                StoreList = res.data.StoreList,
                DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                PurchaseInvoiceGeneration = [],
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rows = [],
                rowsCount = rows.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                LedgerNameList = [],
                DetailList = [],
                ispaid = false,
                PaymentData = [];
              if (
                res.data.PurchaseItemData &&
                res.data.PurchaseItemData.length > 0
              ) {
                rows = res.data.PurchaseItemData;
                rowsCount = rows.length;
              }
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                LedgerNameList = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                PaymentData = res.data.PaymentData;
                ispaid = false;
              } else {
                ispaid = true;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail1 = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }

              if (
                res.data.OtherDetailData &&
                res.data.OtherDetailData.length > 0
              ) {
                res.data.OtherDetailData.map((odd) => {
                  let isFound = 0;
                  rowsOtherDetail.map((rod) => {
                    if (rod.vac_headingvalue === odd.vac_headingvalue) {
                      rod.vac_value = odd.vac_value;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsOtherDetail.push({
                      vac_headingvalue: odd.vac_headingvalue,
                      vac_value: odd.vac_value,
                      bint_displayorderno: rowsOtherDetail.length + 1,
                    });
                  }
                });
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                res.data.PaymentData.map((odd) => {
                  let isFound = 0;
                  rowsPaymentMode.map((rod) => {
                    if (rod.vac_ledgername === odd.vac_ledgername) {
                      // rod.vac_value = odd.vac_value;
                      rod.dec_amount = odd.dec_amount;
                      rod.vac_chequeno = odd.vac_chequeno;
                      rod.vac_referenceno = odd.vac_referenceno;
                      rod.dat_transactiondate = odd.dat_transactiondate;
                      rod.vac_remark = odd.vac_remark;
                      rod.vac_groupname = odd.vac_groupname;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsPaymentMode.push({
                      vac_ledgername: odd.vac_ledgername,
                      dec_amount: odd.dec_amount,
                      vac_chequeno: odd.vac_chequeno,
                      vac_referenceno: odd.vac_referenceno,
                      dat_transactiondate: odd.dat_transactiondate,
                      vac_remark: odd.vac_remark,
                      vac_groupname: odd.vac_groupname,
                      // bint_displayorderno: rowsPaymentMode.length + 1,
                    });
                  }
                });
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (
                res.data.OtherDetailData &&
                res.data.OtherDetailData.length > 0
              ) {
                res.data.OtherDetailData.map((odd) => {
                  let isFound = 0;
                  rowsOtherDetail1.map((rod) => {
                    if (rod.vac_headingvalue === odd.vac_headingvalue) {
                      rod.vac_value = odd.vac_value;
                      isFound++;
                    }
                  });
                  if (isFound === 0) {
                    rowsOtherDetail1.push({
                      vac_headingvalue: odd.vac_headingvalue,
                      vac_value: odd.vac_value,
                      bint_displayorderno: rowsOtherDetail1.length + 1,
                    });
                  }
                });
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }

              if (
                res.data.GeneralSettingList &&
                res.data.GeneralSettingList.length > 0
              ) {
                PurchaseInvoiceGeneration =
                  res.data.GeneralSettingList[0].vac_value;
              }
              // console.log("DetailList", DetailList);
              // console.log("rowsOtherDetail", rowsOtherDetail);
              this.setState(
                {
                  dataLoadStatus: true,

                  ispaid,
                  SupplierList,
                  TaxNameList,
                  ItemNameList,
                  DefaultEntrySettingList,
                  StoreList,
                  PurchaseInvoiceGeneration,
                  rows,
                  rowsCount,
                  rowsOtherDetail,
                  rowsCountOtherDetail,
                  rowsOtherDetail1,
                  rowsCountOtherDetail1,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                  LedgerNameList,
                  DetailList,
                  PaymentData,
                  totalAfterTaxAmt: res.data.PurchaseList[0].dec_aftertaxamt,
                  totalBeforeTaxAmt: res.data.PurchaseList[0].dec_beforetaxamt,
                  totalafterDeductionTaxamt:
                    res.data.PurchaseList[0].totalafterDeductionTaxamt,
                  totalAfteraddTaxamt:
                    res.data.PurchaseList[0].totalAfteraddTaxamt,
                  totalBeforeaddTaxamt:
                    res.data.PurchaseList[0].totalBeforeaddTaxamt,
                  totalBeforeDeductionTaxamt:
                    res.data.PurchaseList[0].totalBeforeDeductionTaxamt,
                  formData: {
                    ...this.state.formData,
                    edit_purchasesrno: res.data.PurchaseList[0].bint_purchaseno,
                    dtpDate: res.data.PurchaseList[0].dat_purchasedate,
                    cmbCompany: res.data.PurchaseList[0].vac_company,
                    txtBillNo: res.data.PurchaseList[0].vac_billno,
                    cmbSupplier: res.data.PurchaseList[0].vac_supplier,
                    // beforTax: res.data.PurchaseList[0].dec_beforetaxamt,
                    // afterTax: res.data.PurchaseList[0].dec_aftertaxamt,
                    txtbasicamt: res.data.PurchaseList[0].dec_basicamt,
                    txtDiscount: res.data.PurchaseList[0].dec_discamt,
                    txtTaxable: res.data.PurchaseList[0].dec_taxableamount,
                    txtCGST: res.data.PurchaseList[0].dec_cgst,
                    txtSGST: res.data.PurchaseList[0].dec_sgst,
                    txtIGST: res.data.PurchaseList[0].dec_igst,
                    txtGrandTotal: res.data.PurchaseList[0].dec_grandtotal,
                    txtAdvPayment: res.data.PurchaseList[0].dec_advpay,
                    txtNetPayment: res.data.PurchaseList[0].dec_netpay,
                    txtRoundOff: res.data.PurchaseList[0].dec_roundoff,
                    cmbTransactionType:
                      res.data.PurchaseList[0].vac_transactiontype,
                    txtRemark: res.data.PurchaseList[0].vac_remark,
                    // txtTDSAmount: res.data.PurchaseList[0].dec_tdsamount,
                    // txtAdvPayment: res.data.PurchaseList[0].dec_advancepayment,
                  },
                },
                () => {
                  if (this.state.formData.cmbTransactionType === "Remain") {
                    this.setState({
                      ispaid: false,
                    });
                  }
                  if (
                    this.state.formData.cmbTransactionType === "Paid" &&
                    !this.state.isEditMode &&
                    !this.state.hasOpenedTransactionType
                  ) {
                    this.setState({ hasOpenedTransactionType: false });
                  } else if (
                    this.state.formData.cmbTransactionType === "Remain"
                  ) {
                    this.setState({
                      isEditMode: false,
                      isInitialLoad: false,
                    });
                  }
                }
              );
            })
            .catch((error) => {
              this.props.toastMsg(
                "error",
                "Unkonwn Error occured in onFormLoad. " + error
              );
            });
        } else {
          const reqData = {
            Op: "PurchaseData",
            bint_acid: localStorage.getItem("acid"),
            bint_acyear: localStorage.getItem("ACY"),
          };
          fetchPurchase(reqData)
            .then((res) => {
              this.setState({ isEditMode: false, isInitialLoad: false });
              dataLoadStatus = true;
              let SupplierList = [],
                TaxNameList = [],
                ItemNameList = [],
                StoreList = [],
                PurchaseInvoiceGeneration = [],
                InvoiceNoList = [],
                DefaultEntrySettingList = [],
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                LedgerNameList = [],
                DetailList = [],
                PaymentData = [];

              if (res.data.supplierList && res.data.supplierList.length > 0) {
                SupplierList = res.data.supplierList;
              }
              if (res.data.TaxList && res.data.TaxList.length > 0) {
                TaxNameList = res.data.TaxList;
              }
              if (res.data.ItemList && res.data.ItemList.length > 0) {
                ItemNameList = res.data.ItemList;
              }
              if (res.data.StoreList && res.data.StoreList.length > 0) {
                StoreList = res.data.StoreList;
              }
              if (
                res.data.GeneralSettingList &&
                res.data.GeneralSettingList.length > 0
              ) {
                PurchaseInvoiceGeneration =
                  res.data.GeneralSettingList[0].vac_value;
              }
              if (res.data.InvoiceNoList && res.data.InvoiceNoList.length > 0) {
                InvoiceNoList = res.data.InvoiceNoList;
              }
              if (
                res.data.DefaultEntrySettingList &&
                res.data.DefaultEntrySettingList.length > 0
              ) {
                DefaultEntrySettingList = res.data.DefaultEntrySettingList;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                LedgerNameList = copyRowsAllCols(
                  res.data.LedgerNameList,
                  this.state.PaymentmodeListCols
                );
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail = rowsOtherDetail.length;
              }

              if (res.data.DetailList && res.data.DetailList.length > 0) {
                rowsOtherDetail1 = res.data.DetailList.map((row) => {
                  return {
                    ...row,
                    txtFormate:
                      row["vac_calculationstyle"] == "Before Tax"
                        ? row["vac_calculation"] +
                          (row["vac_taxname"]
                            ? "(" + row["vac_taxname"] + ")"
                            : "")
                        : row["vac_calculation"],
                  };
                });
                DetailList = res.data.DetailList;
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }

              if (res.data.PaymentData && res.data.PaymentData.length > 0) {
                PaymentData = res.data.PaymentData;
              }
              this.setState(
                {
                  dataLoadStatus,
                  SupplierList,
                  TaxNameList,
                  ItemNameList,
                  StoreList,
                  PurchaseInvoiceGeneration,
                  BillNoList: InvoiceNoList,
                  DefaultEntrySettingList,
                  LedgerNameList,
                  DetailList,
                  PaymentData,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  rowsOtherDetail,
                  rowsCountOtherDetail: rowsOtherDetail.length,
                  rowsOtherDetail1,
                  rowsCountOtherDetail1: rowsOtherDetail1.length,
                  rowsPaymentMode,
                  rowsCountPaymentMode,
                },
                () => {
                  // this.getDefaultBillType()
                  // console.log("this.state", this.state);
                }
              );
            })
            .catch((error) => {
              console.log("Unknown error occurred in onFormLoad.", error);
            });
        }
      }
    );
    // document.getElementById("dtpDate").focus();
  };

  clearInfo = () => {
    let cmbTransactionType = "";
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      cmbTransactionType =
        this.state.DefaultEntrySettingList[0].vac_transacationtype;
    }
    // console.log("this.state.DetailList", this.state.DetailList);
    // console.log("this.state.LedgerNameList", this.state.LedgerNameList);
    this.setState(
      {
        totalAfterTaxAmt: 0,
        totalafterDeductionTaxamt: 0,
        totalAfteraddTaxamt: 0,
        totalBeforeaddTaxamt: 0,
        totalBeforeDeductionTaxamt: 0,
        totalBeforeTaxAmt: 0,
        formData: {
          ...this.state.formData,
          edit_purchasesrno: "",
          dtpDate: get_YMD_from_SYS(new Date()),
          cmbSupplier: "",
          txtBillNo: "",
          txtbasicamt: 0,
          txtDiscount: 0,
          txtTaxable: 0,
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          tblCGST: "",
          tblSGST: "",
          tblIGST: "",
          // txtTDSAmount: "",
          txtGrandTotal: "",
          txtAdvPayment: "",
          txtRoundOff: "",
          txtNetPayment: "",
          cmbTransactionType,
          txtRemark: "",
        },
        rows: [],
        rowsCount: 0,
        rowsOtherDetail: this.state.rowsOtherDetail,
        rowsCountOtherDetail: this.state.rowsOtherDetail.length,
        rowsOtherDetail1: this.state.rowsOtherDetail1,
        rowsCountOtherDetail1: this.state.rowsOtherDetail1.length,
        rowsPaymentMode: copyRowsAllCols(
          this.state.LedgerNameList,
          this.state.PaymentmodeListCols
        ),
        rowsCountPaymentMode: this.state.LedgerNameList.length,
        PaymentData: [],
      },
      () => {
        this.props.navigateTo("Purchasenew");
      }
    );
  };

  savePurchase = () => {
    if (
      this.validatePurchase() &&
      this.validatePurchaseItemCount() &&
      this.validatePaymentModeAmount()
    ) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      let rowsTotal = getRowColSum(this.state.rows, [
        "dec_cgstamt",
        "dec_sgstamt",
        "dec_igstamt",
      ]);

      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SavePurchase_Item",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          vac_company: localStorage.getItem("CompanyName"),
          bint_purchaseno: this.state.formData.edit_purchasesrno,
          dat_purchasedate: this.state.formData.dtpDate,
          vac_billtype: this.state.formData.cmbBillType,
          vac_billno: this.state.formData.txtBillNo,
          vac_supplier: this.state.formData.cmbSupplier,
          dec_discamt: this.state.formData.txtDiscount,
          dec_taxableamount: this.state.formData.txtTaxable,
          // dec_tdsamount: this.state.formData.txtTDSAmount,
          dec_cgst: this.state.formData.txtCGST,
          dec_sgst: this.state.formData.txtSGST,
          dec_igst: this.state.formData.txtIGST,
          dec_grandtotal: this.state.formData.txtGrandTotal,
          dec_advpay: this.state.formData.txtAdvPayment,
          dec_roundoff: this.state.formData.txtRoundOff,
          dec_netpay: this.state.formData.txtNetPayment,
          vac_transactiontype: this.state.formData.cmbTransactionType,
          bint_vouno: 0,
          vac_remark: this.state.formData.txtRemark,
          PaymentData: this.getPaymentModeDataStatus()
            ? this.state.rowsPaymentMode
            : [],
          OtherDetailData: [
            ...this.state.rowsOtherDetail,
            ...this.state.rowsOtherDetail1,
          ],
          dec_basicamt: this.state.formData.txtbasicamt,
          totalafterDeductionTaxamt: this.state.totalafterDeductionTaxamt,
          totalAfteraddTaxamt: this.state.totalAfteraddTaxamt,
          totalBeforeaddTaxamt: this.state.totalBeforeaddTaxamt,
          totalBeforeDeductionTaxamt: this.state.totalBeforeDeductionTaxamt,
          dec_beforetaxamt: this.state.totalBeforeTaxAmt,
          dec_aftertaxamt: this.state.totalAfterTaxAmt,
          bint_ci: localStorage.getItem("CI"),
        };
        fetchPurchase(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let DefaultEntrySettingList = res.data.DefaultEntrySettingList,
                cmbTransactionType = "",
                rowsOtherDetail = [],
                rowsCountOtherDetail = rowsOtherDetail.length,
                rowsOtherDetail1 = [],
                rowsCountOtherDetail1 = rowsOtherDetail1.length,
                rowsPaymentMode = [],
                rowsCountPaymentMode = rowsPaymentMode.length,
                StoreList = [],
                PurchaseInvoiceGeneration = [],
                LedgerNameList = [],
                DetailList = [],
                SupplierList = [],
                ItemNameList = [],
                TaxNameList = [];
              if (
                res.data.LedgerNameList &&
                res.data.LedgerNameList.length > 0
              ) {
                rowsPaymentMode = res.data.LedgerNameList;
                LedgerNameList = res.data.LedgerNameList;
                rowsCountPaymentMode = rowsPaymentMode.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                DetailList = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsOtherDetail = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsCountOtherDetail = rowsOtherDetail.length;
              }
              if (res.data.DetailList && res.data.DetailList.length > 0) {
                DetailList = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsOtherDetail1 = copyRowsAllCols(
                  res.data.DetailList,
                  this.state.DetailListCols
                );
                rowsCountOtherDetail1 = rowsOtherDetail1.length;
              }
              if (DefaultEntrySettingList.length > 0) {
                cmbTransactionType =
                  DefaultEntrySettingList[0].vac_transacationtype;
              }
              if (res.data.StoreList.length > 0) {
                StoreList = res.data.StoreList;
              }
              if (res.data.TaxList.length > 0) {
                TaxNameList = res.data.TaxList;
              }
              if (res.data.ItemList.length > 0) {
                ItemNameList = res.data.ItemList;
              }
              if (res.data.supplierList.length > 0) {
                SupplierList = res.data.supplierList;
              }
              // console.log("rowsPaymentMode", rowsPaymentMode);
              // console.log("rowsOtherDetail", rowsOtherDetail);
              this.setState(
                {
                  dataLoadStatus: true,
                  StoreList,
                  LedgerNameList,
                  DetailList,
                  SupplierList,
                  ItemNameList,
                  TaxNameList,
                  DefaultEntrySettingList,
                  formData: {
                    ...this.state.formData,
                    cmbTransactionType,
                  },
                  // rowsOtherDetail,
                  // rowsCountOtherDetail,
                  // rowsPaymentMode,
                  // rowsCountPaymentMode,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in savePurchase.", error);
          });
      });
    }
  };

  hasHtmlFormatting = (text) => {
    if (!text) return false;

    const div = document.createElement("div");
    div.innerHTML = text;

    const cleanedText = text.replace(/<p>\s*<\/p>/gi, "");

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = cleanedText;

    const isVisiblyEmpty = tempDiv.textContent.trim() === "";
    const hasTags = /<[^>]+>/.test(cleanedText);

    const result = !isVisiblyEmpty && hasTags;

    return result;
  };

  openRichTextBox = (Heading, id, TxtChange) => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Set"
          fullscreenOnly={true}
          alertIcon=""
          alertTitle={Heading}
          alertMessage={
            <MoreInfoTextEditor
              TxtChange={TxtChange}
              Txtid={id}
              updateDetails={this.updateDetails}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );

      this.setState({ ARD });
    });
  };
  updateDetails = (id, Details) => {
    let txtRemark = this.state.formData.txtRemark,
      withoutText = Details.replace(/<[^>]*>/g, "").trim();

    if (withoutText.length <= 0) {
      Details = withoutText;
    }

    if (id === "Remark") {
      txtRemark = Details;
    }

    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtRemark,
        },
      },
      () => {}
    );
  };

  onDeleteBtnClick = () => {
    if (this.state.formData.edit_purchasesrno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Bill No. : " +
              this.state.formData.txtBillNo +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deletePurchase(this.state.formData.edit_purchasesrno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no Purchase to delete", "dtpDate");
    }
  };

  deletePurchase = (edit_purchasesrno) => {
    if (edit_purchasesrno > 0) {
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus: false }, () => {
        const reqData = {
          Op: "DeletePurchase",
          bint_acyear: localStorage.getItem("ACY"),
          bint_acid: localStorage.getItem("acid"),
          edit_purchaseno: edit_purchasesrno,
          dat_fromdate: "",
          dat_todate: "",
        };
        fetchPurchase(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              this.setState({ ARD: null, dataLoadStatus: true }, () => {
                this.clearInfo();
              });
            } else {
              this.setState({ dataLoadStatus: true });
            }
          })
          .catch((error) => {
            this.props.updateProcessing(
              "error",
              "Unknown error occurred in delete deletePurchase. " + error
            );
          });
      });
    } else {
      this.props.notifyProcessing();
      this.props.updateProcessing(
        "error",
        "There are no Purchase records to delete."
      );
    }
  };

  deletePurchaseItem = (
    bint_acyear,
    bint_acid,
    edit_purchasesrno,
    bint_itemsrno
  ) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      this.props.notifyProcessing();
      const reqData = {
        Op: "DeletePurchaseItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_purchaseno: edit_purchasesrno,
        edit_itemsrno: bint_itemsrno,
        dec_advpay: this.state.formData.txtAdvPayment,
        dec_roundoff: this.state.formData.txtRoundOff,
        vac_supplier: this.state.formData.cmbSupplier,
        bint_ci: localStorage.getItem("CI"),
        dat_purchasedate: this.state.formData.dtpDate,
        vac_remark: this.state.formData.txtRemark,
        vac_transactiontype: this.state.formData.cmbTransactionType,
        PaymentData: this.state.rowsPaymentMode,
        vac_billno: this.state.formData.txtBillNo,
        // dec_tdsamount: this.state.formData.txtTDSAmount,
        dec_advancepayment: this.state.formData.txtAdvPayment,
      };
      console.log("reqData", reqData);
      fetchPurchase(reqData)
        .then((res) => {
          this.props.updateProcessing(res.data.msgType, res.data.message);
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            PurchaseItemData = [];
          if (
            res.data.PurchaseItemData &&
            res.data.PurchaseItemData.length > 0
          ) {
            rows = res.data.PurchaseItemData;
            rowsCount = rows.length;
          }
          if (res.data.TotalItemAmountData) {
            dec_basicamt = Number(res.data.TotalItemAmountData[0].dec_basicamt);
            dec_disamt = Number(res.data.TotalItemAmountData[0].dec_disamt);
            dec_taxable = Number(
              res.data.TotalItemAmountData[0].dec_taxableamount
            );
            dec_cgstamt = Number(res.data.TotalItemAmountData[0].dec_cgstamt);
            dec_sgstamt = Number(res.data.TotalItemAmountData[0].dec_sgstamt);
            dec_igstamt = Number(res.data.TotalItemAmountData[0].dec_igstamt);
            dec_totalamt = Number(
              res.data.TotalItemAmountData[0].dec_totalamount
            );
          }
          this.resetAmount(
            dec_basicamt,
            dec_taxable,
            dec_cgstamt,
            dec_sgstamt,
            dec_igstamt,
            dec_totalamt,
            dec_disamt,
            edit_purchasesrno
          );
          this.setState({
            ARD: null,
            rows,
            rowsCount,
            dataLoadStatus,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in deletePurchaseItem.", error);
        });
    });
    return true;
  };

  refreshPurchaseItemList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  resetAmount = (
    txtbasicamt,
    txtTaxable,
    txtCGST,
    txtSGST,
    txtIGST,
    txtGrandTotal,
    txtDiscount,
    // txtBasicAmt,
    edit_purchasesrno
  ) => {
    // console.log("resetAmount", txtTaxable, txtCGST, txtSGST, txtIGST);
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtbasicamt: txtbasicamt.toFixed(2),
          txtTaxable: txtTaxable.toFixed(2),
          txtCGST,
          txtSGST,
          txtIGST,
          txtGrandTotal,
          // txtBasicAmt,
          txtDiscount: txtDiscount.toFixed(2),
          edit_purchasesrno,
        },
      },
      () => {
        // console.log("this.state.formData", this.state.formData);
        // this.calNetAmount();
      }
    );
  };

  // calNetAmount = () => {
  //   let txtNetPayment =
  //       Number(this.state.formData.txtGrandTotal) -
  //       Number(this.state.formData.txtAdvPayment),
  //     txtRoundOff = 0;
  //   let arrNetPayment = getRoundOff(txtNetPayment);
  //   txtNetPayment = arrNetPayment["roff_number"];
  //   txtRoundOff = arrNetPayment["roff"];
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //         txtNetPayment,
  //         txtRoundOff,
  //       },
  //     },
  //     () => {
  //       // console.log("this.state.formData", this.state.formData);
  //     }
  //   );
  // };

  getStateCodeOFPurchase = () => {
    if (this.state.formData.cmbSupplier.length > 0) {
      let SupplierStateCode = 0;
      this.state.SupplierList.map((row) => {
        if (row.vac_supplier === this.state.formData.cmbSupplier) {
          SupplierStateCode = row.vac_statecode;
          this.setState({
            SupplierStateCode: row.vac_statecode,
          });
        }
      });
      // console.log("SupplierStateCode", SupplierStateCode);
      if (SupplierStateCode != localStorage.getItem("CompStateCode")) {
        let rowsTotal = getRowColSum(this.state.rows, [
          "dec_cgstamt",
          "dec_sgstamt",
          "dec_igstamt",
        ]);
        let CGST =
          Number(this.state.formData.txtCGST) != 0
            ? Number(this.state.formData.txtCGST)
            : Number(rowsTotal.dec_cgstamt) +
              Number(this.state.formData.tblCGST);
        let SGST =
          Number(this.state.formData.txtSGST) != 0
            ? Number(this.state.formData.txtSGST)
            : Number(rowsTotal.dec_sgstamt) +
              Number(this.state.formData.tblSGST);
        let IGST =
          Number(this.state.formData.txtIGST) != 0
            ? Number(this.state.formData.txtIGST)
            : Number(rowsTotal.dec_igstamt) +
              Number(this.state.formData.tblIGST);
        console.log("CGST SGST IGST", CGST, SGST, IGST);
      } else if (SupplierStateCode == localStorage.getItem("CompStateCode")) {
        let rowsTotal = getRowColSum(this.state.rows, [
          "dec_cgstamt",
          "dec_sgstamt",
          "dec_igstamt",
        ]);
        let IGST =
          Number(this.state.formData.txtIGST) != 0
            ? Number(this.state.formData.txtIGST)
            : Number(rowsTotal.dec_igstamt) +
              Number(this.state.formData.tblIGST);

        let CGST = IGST / 2;

        let SGST = IGST / 2;

        IGST = 0;

        console.log("CGST SGST IGST", CGST, SGST, IGST);
      }
    }
  };

  getSupplierList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadSupplierDetails",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchSupplierMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Supplier List Loaded");
        let SupplierList = res.data.supplierList;
        this.setState(
          {
            SupplierList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getPurchaseList.", error);
      });
  };

  getDetailList = () => {
    // console.log("dtail list");
    this.props.notifyProcessing();
    const reqData = {
      Op: "DetailList",
      bint_acid: localStorage.getItem("acid"),
      vac_detailtype: "",
    };
    fetchDetailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Detial List Loaded");
        let rowsOtherDetail = res.data.DetailList,
          rowsCountOtherDetail = 0,
          rowsOtherDetail1 = res.data.DetailList,
          rowsCountOtherDetail1 = 0;

        this.setState({
          rowsOtherDetail,
          rowsCountOtherDetail,
          rowsOtherDetail1,
          rowsCountOtherDetail1,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in getDetailList.", error);
      });
  };

  onAddClickSupplier = () => {
    this.setState({ ARD: null }, () => {
      this.removeKeyboardShortCuts();
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<SupplierMaster showHeading={true} />
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getSupplierList();
            this.ShortCut();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getItemList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ItemList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchItemMaster(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Item List Loaded");
        let ItemNameList = res.data.ItemList;
        this.setState(
          {
            ItemNameList,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getItemList.", error);
      });
  };

  getPayRemarkLblVisibleStatus = () => {
    return this.state.formData.cmbTransactionType == "Remain" &&
      Number(this.state.formData.txtAdvPayment) > 0
      ? true
      : false;
  };

  getPaymentModeDataStatus = () => {
    let result = false;
    if (
      this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
    ) {
      result = true;
    } else {
      this.state.rowsPaymentMode.map((row) => {
        // row.vac_ledgername = ''
        row.dec_amount = "";
        row.vac_chequeno = "";
        row.vac_referenceno = "";
        row.dat_transactiondate = "";
        row.vac_remark = "";
      });
    }
    return result;
    /* return this.state.formData.cmbTransactionType == "Paid" ||
      this.getPayRemarkLblVisibleStatus()
      ? true
      : false; */
  };

  setSaveBtnDisplay = () => {
    let isParamFound =
      this.props.params &&
      this.props.params.EditPurchaseSrNo &&
      this.props.params.EditPurchaseSrNo.substring(1).length > 0;
    if (isParamFound !== true) {
      isParamFound = false;
    }
    let paramEditPurchaseSrNo = 0;
    if (isParamFound) {
      var editInfo = this.props.params.EditPurchaseSrNo.split(":");
      paramEditPurchaseSrNo = Number(editInfo[2]);
      if (paramEditPurchaseSrNo <= 0) {
        isParamFound = false;
      }
    }
    if (this.props.userPrivilege.Purchase == "M") {
      return "block";
    } else if (this.props.userPrivilege.Purchase == "R") {
      return "none";
    } else if (
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) > Number(0) &&
        isParamFound === false) ||
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) > Number(0) &&
        isParamFound === true &&
        Number(this.state.formData.edit_purchasesrno) !==
          Number(paramEditPurchaseSrNo)) ||
      (this.props.userPrivilege.Purchase == "W" &&
        Number(this.state.formData.edit_purchasesrno) <= Number(0))
    ) {
      return "block";
    } else {
      return "none";
    }
  };

  setPaymentData = (rowsPaymentMode) => {
    this.setState(
      {
        rowsPaymentMode,
      },
      () => {
        // console.log("this.state.rows", this.state.rows);
      }
    );
  };

  getDefaultEntrySettingRow = () => {
    let DefaultEntrySettingList = [];
    if (
      this.state.DefaultEntrySettingList &&
      this.state.DefaultEntrySettingList.length > 0
    ) {
      if (
        this.state.DefaultEntrySettingList[0].vac_transacationtype == "Paid"
      ) {
        DefaultEntrySettingList = this.state.DefaultEntrySettingList[0];
      } else {
        if (
          this.state.DefaultEntrySettingList[1].vac_transacationtype == "Paid"
        ) {
          DefaultEntrySettingList = this.state.DefaultEntrySettingList[1];
        }
      }
    }
    return DefaultEntrySettingList;
  };

  getEnabledAdvPaymentStatus = () => {
    if (this.state.formData.cmbTransactionType === "Paid") {
      return false;
    } else {
      return true;
    }
  };
  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    // this.togglePaymentModeInfo(); // Set anchor element to the clicked target
  };

  handleClose = () => {
    this.setState({ anchorEl: null }); // Close the menu
  };

  handleSelectTransactionType = () => {
    if (!(this.state.isEditMode && this.state.isInitialLoad)) {
      // Only open if NOT in edit mode
      this.openTransactionType();
      this.getPaymentModeDataStatus();
    }

    // if (type === " Advance") {
    //   this.getPaymentModeDataStatus();
    //   this.openTransactionType();
    // }
    // Update transaction type
  };

  openTransactionType = () => {
    let ARD = null;
    const { PaymentData, rowsPaymentMode } = this.state;
    let DefaultEntrySettingList = this.getDefaultEntrySettingRow();

    const txtAmount4PaymentModeTable = Number(
      this.state.formData.txtNetPayment
    );

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={
            <PaymentModeTable
              DefaultEntrySettingList={DefaultEntrySettingList}
              PaymentData={PaymentData}
              PaymentLedgerNameList={rowsPaymentMode}
              Edit_SrNo={this.state.formData.edit_purchasesrno}
              setPaymentData={this.setPaymentData}
              txtAmount={txtAmount4PaymentModeTable}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
          handleOnClickNo={() => {
            this.setState({ ARD: null });
          }}
        />
      );
      this.setState({ ARD });
      console.log("rowsPaymentMode:", this.state.rowsPaymentMode);
    });
  };
  getPaymentModeInfoAsText = () => {
    const { rowsPaymentMode } = this.state;

    if (rowsPaymentMode.length === 0) {
      return "No payment mode information available.";
    }

    return rowsPaymentMode
      .map((row, index) => {
        return `Payment Mode ${index + 1}: 
        Ledger Name: ${row.vac_ledgername || "N/A"}, 
        Amount: ${row.dec_amount || "0"}, 
        Cheque No: ${row.vac_chequeno || "N/A"}, 
        Reference No: ${row.vac_referenceno || "N/A"}, 
        Transaction Date: ${row.dat_transactiondate || "N/A"}, 
        Remark: ${row.vac_remark || "N/A"}`;
      })
      .join("\n");
  };
  refreshPaymentList = (rows, rowsCount) => {
    this.setState({
      rows,
      rowsCount,
    });
  };

  PaymenMode = () => {
    let ARD = null;
    const txtAdvPayment = this.state.formData.txtAdvPayment;
    const cmbSupplier = this.state.formData.cmbSupplier;

    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          // alertTitle={'Sales Item Entry'}
          alertMessage={
            <PaymentEntry
              refreshPaymentList={this.refreshPaymentList}
              txtAdvPayment={txtAdvPayment}
              cmbSupplier={cmbSupplier}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      expanded: !prevState.expanded,
    }));
  };

  //#endregion function

  render() {
    const { SupplierList, totals } = this.state;
    const isDisplaySaveBtn = this.setSaveBtnDisplay();
    let rowsTotal = getRowColSum(this.state.rows, [
      "dec_cgstamt",
      "dec_sgstamt",
      "dec_igstamt",
    ]);

    console.log("rowOtherDetail", this.state.rowsOtherDetail1);

    let CGST =
      Number(this.state.formData.txtCGST) != 0
        ? Number(this.state.formData.txtCGST)
        : Number(rowsTotal.dec_cgstamt) + Number(this.state.formData.tblCGST);
    let SGST =
      Number(this.state.formData.txtSGST) != 0
        ? Number(this.state.formData.txtSGST)
        : Number(rowsTotal.dec_sgstamt) + Number(this.state.formData.tblSGST);
    let IGST =
      Number(this.state.formData.txtIGST) != 0
        ? Number(this.state.formData.txtIGST)
        : Number(rowsTotal.dec_igstamt) + Number(this.state.formData.tblIGST);
    let txtsubtotal =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt);
    txtsubtotal = txtsubtotal.toFixed(2);
    let txtsubtotal1 =
      Number(this.state.formData.txtTaxable) +
      Number(this.state.totalBeforeTaxAmt) +
      CGST +
      SGST +
      IGST +
      Number(this.state.totalAfterTaxAmt);
    let txtsubGrandtotal = txtsubtotal1.toFixed(2);

    let arrGrandTotal = getRoundOff(txtsubtotal1);

    let txtGrandTotal = arrGrandTotal["roff_number"].toFixed(2);

    let NetPayment =
      Number(txtsubGrandtotal) - Number(this.state.formData.txtAdvPayment);
    let arrNetPayment = getRoundOff(NetPayment);
    NetPayment = arrNetPayment["roff_number"].toFixed(2);
    let txtRoundOff = arrNetPayment["roff"].toFixed(2);

    let txtbasicamt = parseFloat(this.state.formData.txtbasicamt) || 0,
      txtDiscount = parseFloat(this.state.formData.txtDiscount) || 0,
      totalBeforeaddTaxamt = parseFloat(this.state.totalBeforeaddTaxamt) || 0,
      totalBeforeDeductionTaxamt =
        parseFloat(this.state.totalBeforeDeductionTaxamt) || 0,
      totalAfteraddTaxamt = parseFloat(this.state.totalAfteraddTaxamt) || 0,
      totalafterDeductionTaxamt =
        parseFloat(this.state.totalafterDeductionTaxamt) || 0,
      txtTaxable = parseFloat(this.state.formData.txtTaxable) || 0;

    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Purchase Entry</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="space-evenly"
          alignItems="flex-start"
          spacing={0}
          marginTop={2}
        >
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtDtp
                  id="dtpDate"
                  value={this.state.formData.dtpDate}
                  label="Date*"
                  handleOnChange={this.handleOnChange}
                  accountYear={localStorage.getItem("ACY")}
                  onKeyDown={this.props.onKeyDown}
                  // disabled={true}
                  width={170}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtBillNo"
                  label="Bill Number*"
                  value={this.state.formData.txtBillNo}
                  handleOnChange={this.handleOnChange}
                  width={170}
                  nextCtrlID="cmbSupplier"
                  onKeyDown={this.props.onKeyDown}
                  maxLength={100}
                />
              </Grid>{" "}
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbSupplier"
                  label="Supplier Name*"
                  items={getRowColData(SupplierList, "vac_supplier")}
                  value={this.state.formData.cmbSupplier}
                  handleOnChange={this.handleOnChange}
                  width={270}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  colID="vac_supplier"
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onAddClickSupplier}
                  nextCtrlID="txtRemark"
                />
              </Grid>
              {/* <Grid item>
                <CtTxtAmt
                  id="PhoneNo"
                  label="Phone No"
                  value={this.state.formData.PhoneNo}
                  handleOnChange={this.handleOnChange}
                  nextCtrlID="txtRemark"
                  onKeyDown={this.props.onKeyDown}
                  width={170}
                  maxLength={10}
                />
              </Grid> */}
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              {" "}
              <Grid item lg={8} md={8} sm={12} xs={12}>
                {!this.hasHtmlFormatting(this.state.formData.txtRemark) ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <CtMultiLineText
                        id="txtRemark"
                        label="Remark"
                        value={this.state.formData.txtRemark}
                        handleOnChange={this.handleOnChange}
                        width="100%"
                        maxLength={1000}
                        // onKeyDown={this.props.onKeyDown}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the input field
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "8px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "4px",
                          color: "#666666",
                          fontSize: "14px",
                          fontWeight: 500,
                        }}
                      >
                        Remark
                      </label>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.formData.txtRemark,
                        }}
                        style={{
                          minHeight: "100px",
                          padding: "8px 12px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          background: "#f9f9f9",
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          lineHeight: "1.5",
                          fontFamily:
                            "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                        }}
                      />
                    </div>
                    <Edit
                      className="child-button"
                      style={{
                        marginTop: "26px", // aligns with the top of remark box
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        color: "#1976d2",
                      }}
                      onClick={() => {
                        this.openRichTextBox(
                          "Remark",
                          "Remark",
                          this.state.formData.txtRemark
                        );
                      }}
                    />
                  </div>
                )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12} lg={6}>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                {this.state.formData.cmbSupplier.length > 0 ? (
                  <TableList
                    columns={this.state.columnsOtherDetail}
                    counter={this.state.counter}
                    rows={this.state.rowsOtherDetail.filter(
                      (row) => row.vac_calculation === ""
                    )}
                    rowsCount={this.state.rowsCountOtherDetail}
                    rowsPerPage={this.state.rowsPerPageOtherDetail}
                    handleChangeRowsPerPage={
                      this.handleChangeRowsPerPageOtherDetail
                    }
                    handleOnRowDataChange={
                      this.handleOnRowDataChangeOtherDetail
                    }
                  />
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item display={isDisplaySaveBtn}>
            <div
              style={{
                position: "fixed",
                top: "100px",
                right: "20px",
                zIndex: 1000,
                display: "flex",
                gap: "10px", // space between buttons
                backgroundColor: "white",
              }}
            >
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  this.props.navigateTo("PurchaseList");
                }}
              >
                Purchase List
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.savePurchase()}
              >
                Save
              </Button>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    this.trimFormData(() => {
                      this.savePurchase(true);
                    });
                  }}
                >
                  Print Invoice
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleInvoice}
                >
                  E-Invoice
                </Button>
              </Grid>
            </div>
          </Grid> */}

          <Grid item>
            <Slide in={true} direction="left">
              <div
                style={{
                  position: "fixed",
                  top: "65px",
                  right: "1px",
                  zIndex: 1000,
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "white",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "8px",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                <Tooltip
                  title={this.state.expanded ? "Hide Actions" : "Show Actions"}
                  arrow
                  display={isDisplaySaveBtn}
                >
                  <Button onClick={this.handleToggle}>
                    {this.state.expanded ? <Close /> : <MoreHoriz />}
                  </Button>
                </Tooltip>

                <Collapse in={!this.state.expanded} orientation="horizontal">
                  <Box sx={{ display: "flex", gap: 1, ml: 1 }}>
                    <Tooltip title="Save">
                      <IconButton
                        onClick={() => {
                          this.trimFormData(() => {
                            this.savePurchase(false);
                          });
                        }}
                      >
                        <Save sx={{ color: "#3487d7" }} />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Purchase List">
                      <IconButton
                        onClick={() => {
                          this.props.navigateTo("PurchaseList");
                        }}
                      >
                        <ViewList />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="New">
                      <IconButton onClick={this.clearInfo}>
                        <AddBox />
                      </IconButton>
                    </Tooltip>

                    {this.props.userPrivilege.Purchase === "M" && (
                      <Tooltip title="Delete">
                        <IconButton onClick={this.onDeleteBtnClick}>
                          <Delete sx={{ color: "#fe6969" }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </Collapse>

                <Collapse in={this.state.expanded} orientation="horizontal">
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      marginLeft: 1,
                    }}
                  >
                    <Grid item display={isDisplaySaveBtn}>
                      <CtBtn
                        label="Save"
                        className="Primary"
                        onClick={() => {
                          this.trimFormData(() => {
                            this.savePurchase();
                          });
                        }}
                      />
                    </Grid>

                    <Grid item>
                      <CtBtn
                        label="Purchase List"
                        variant="outlined"
                        iconName={"List"}
                        onClick={() => {
                          this.props.navigateTo("PurchaseList");
                        }}
                      />
                    </Grid>

                    <Grid item>
                      <CtBtn
                        variant="outlined"
                        className="Secondary"
                        label="New"
                        onClick={this.clearInfo}
                      />
                    </Grid>
                    <Grid
                      item
                      display={
                        this.props.userPrivilege.Purchase !== "M"
                          ? "none"
                          : "block"
                      }
                    >
                      <CtBtn
                        className="Delete"
                        label="Delete"
                        onClick={this.onDeleteBtnClick}
                        disabled={
                          this.state.formData.edit_purchasesrno > 0
                            ? false
                            : true
                        }
                      />
                    </Grid>
                  </Box>
                </Collapse>
              </div>
            </Slide>
          </Grid>
        </Grid>{" "}
        <Grid item marginTop={3} className="maintable">
          <TableContainer component={Paper}>
            {/* <TableList
              columns={this.state.columns}
              counter={this.state.counter}
              rows={this.state.rows}
              rowsCount={this.state.rowsCount}
              rowsPerPage={this.state.rowsPerPage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              handleOnActionClick={this.handleARDonActionClick}
              actionList={this.state.actionList}
              keyColumn={this.state.keyColumn}
              handleOnSearchChange={this.handleOnSearchChange}
              searchColumns={this.state.searchColumns}
              searchData={this.state.searchData}
              provideSearch={true}
              handleOnNewEntryClick={() => {
                this.trimFormData(this.handleOnNewEntryClick);
              }}
            /> */}
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columns}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("PurchaseEntry")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              tableButtonAction={[
                {
                  label: "Purchase Item Entry",
                  onClick: this.handleOnNewEntryClick,
                  addPluseIcon: true,
                },
              ]}
              showColumnFilters={false}
              hideColIdList={["bint_purchaseno"]}
              actionColSize={50}
              density={"compact"}
            />
          </TableContainer>
        </Grid>
        <FormControl fullWidth>
          <Box display="flex" justifyContent="space-between" marginTop={2}>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-start"
              marginTop={2}
            >
              <Box
                display="flex"
                flexDirection="row"
                alignItems="flex-start"
                marginTop={2}
                gap={2}
              >
                <h4
                  variant="h6"
                  style={{
                    color: "blue",
                    cursor: "pointer",
                  }}
                >
                  Transaction Type :
                </h4>

                <Grid item>
                  <CtCmb
                    id="cmbTransactionType"
                    label=""
                    items={this.state.Type}
                    value={this.state.formData.cmbTransactionType}
                    handleOnChange={this.handleOnChange}
                    width={85}
                    maxLength={100}
                    onKeyDown={this.props.onKeyDown}
                    nextCtrlID="txtWayBridgeCharge"
                    disabled={
                      this.state.ispaid === true &&
                      this.state.formData.cmbTransactionType === "Paid"
                    }
                  />
                </Grid>
                {this.state.formData.cmbTransactionType === "Paid" &&
                  this.state.ispaid !== true && (
                    <img
                      src={PaymentModeIcon}
                      alt="Payment Mode"
                      style={{
                        marginTop: "14px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        cursor: "pointer",
                        width: "34px", // Adjust as needed
                        height: "34px",
                      }}
                      onClick={this.openTransactionType}
                    />
                  )}
              </Box>
              {this.state.formData.cmbTransactionType === "Paid" ? (
                <Box>
                  {this.state.rowsPaymentMode.map((row, index) => {
                    if (this.state.formData.cmbTransactionType === "Paid") {
                      const backgroundprocess = row.vac_backgroundprocess;

                      if (row.dec_amount) {
                        switch (backgroundprocess) {
                          case "Cash":
                            return (
                              <Box>
                                <h4 style={{ margin: 5 }}>
                                  Payment Mode: {row.vac_ledgername}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Amount: {row.dec_amount}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Cheque No: {row.vac_chequeno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Reference No: {row.vac_referenceno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Transaction Date:{" "}
                                  {row.dat_transactiondate
                                    ? moment(row.dat_transactiondate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Remark: {row.vac_remark}
                                </h4>
                                <hr />
                              </Box>
                            );
                          case "Cheque":
                            return (
                              <Box>
                                <h4 style={{ margin: 5 }}>
                                  Payment Mode: {row.vac_ledgername}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Amount: {row.dec_amount}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Cheque No: {row.vac_chequeno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Reference No: {row.vac_referenceno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Transaction Date:{" "}
                                  {row.dat_transactiondate
                                    ? moment(row.dat_transactiondate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Remark: {row.vac_remark}
                                </h4>
                                <hr />
                              </Box>
                            );
                          case "Bank":
                            return (
                              <Box>
                                <h4 style={{ margin: 5 }}>
                                  Payment Mode: {row.vac_ledgername}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Amount: {row.dec_amount}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Cheque No: {row.vac_chequeno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Reference No: {row.vac_referenceno}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Transaction Date:{" "}
                                  {row.dat_transactiondate
                                    ? moment(row.dat_transactiondate).format(
                                        "DD-MM-YYYY"
                                      )
                                    : ""}
                                </h4>
                                <h4 style={{ margin: 5 }}>
                                  Remark: {row.vac_remark}
                                </h4>
                                <hr />
                              </Box>
                            );
                          default:
                            return null;
                        }
                      }
                      return null;
                    } else {
                      return null;
                    }
                  })}
                </Box>
              ) : null}
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              position="sticky"
              top={0}
            >
              <Grid item sm={12} lg={6}>
                <Grid
                  container
                  direction="column"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                  marginTop={0}
                >
                  <Grid item sm={12} lg={6}>
                    <Grid
                      container
                      direction="column"
                      justifyContent="flex-start"
                      alignItems="flex-start"
                      spacing={2}
                      marginTop={0}
                    >
                      <Grid item>
                        {this.state.formData.cmbSupplier.length > 0 ? (
                          <TableList
                            columns={this.state.columnsOtherDetail}
                            counter={this.state.counter}
                            rows={this.state.rowsOtherDetail1.filter(
                              (row) => row.vac_calculation !== ""
                            )}
                            rowsCount={this.state.rowsCountOtherDetail1}
                            rowsPerPage={this.state.rowsPerPageOtherDetail1}
                            handleChangeRowsPerPage={
                              this.handleChangeRowsPerPageOtherDetail1
                            }
                            handleOnRowDataChange={
                              this.handleOnRowDataChangeOtherDetail1
                            }
                          />
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>

            <Box
              display="flex"
              flexDirection="column"
              alignItems="flex-end"
              position="sticky"
              top={0}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginBottom: 10,
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Amount:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtbasicamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Item Discount:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtDiscount.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Deduction (BT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalBeforeDeductionTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Charges (BT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalBeforeaddTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Taxable:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtTaxable.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Sub Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtsubtotal}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total CGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {CGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total SGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {SGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total IGST:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {IGST.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Deduction (AT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalafterDeductionTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Total Other Charges (AT):
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {totalAfteraddTaxamt.toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      Sub Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtsubGrandtotal}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ textAlign: "left", padding: "5px" }}>
                      RoundOff:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtRoundOff}
                    </td>
                  </tr>
                  <tr style={{ borderTop: "1px solid #000" }}>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      Grand Total:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {txtGrandTotal}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <CtTxt
                id="txtTDSAmount"
                label="TDS Amount"
                handleOnChange={this.handleOnChange}
                value={this.state.formData.txtTDSAmount}
                width={110}
                maxLength={10}
                textAlign="right"
                onKeyDown={this.props.onKeyDown}
                nextCtrlID="txtAdvPayment"
              /> */}

              <Box
                display="flex"
                justifyContent="flex-end"
                gap={3}
                style={{ marginTop: 10 }}
              >
                {this.state.formData.cmbCustomer &&
                  this.state.formData.txtAdvPayment > 0 && (
                    <CtBtn
                      label="Generated Receipt"
                      onClick={this.PaymenMode}
                    />
                  )}

                <CtTxtAmt
                  id="txtAdvPayment"
                  label="Adv Payment"
                  value={this.state.formData.txtAdvPayment}
                  handleOnChange={this.handleOnChange}
                  width={110}
                  textAlign="right"
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                />
              </Box>

              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  marginTop: 10,
                }}
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      Net Payment:
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                        padding: "5px",
                        fontWeight: "bold",
                      }}
                    >
                      {NetPayment}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Box>
          </Box>
        </FormControl>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(PurchaseEntry))));
